var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveLinkHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 58,
    viewBox: "0 0 9 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.147997 2.95067C-0.147998 1.32106 -1.46906 0 -3.09867 0C-4.72828 0 -6.04934 1.32106 -6.04934 2.95067V16.1494C-6.04934 20.1242 -9 23.8334 -9 27.8082C-9 31.7831 -6.04934 35.4922 -6.04934 39.4671V55.0493C-6.04934 56.6789 -4.72828 58 -3.09867 58C-1.46906 58 -0.147998 56.6789 -0.147997 55.0493L-0.147995 46.4794C-0.147993 40.1168 7.43344 35.1402 8.60408 28.8862C8.6699 28.5346 8.70402 28.1746 8.70402 27.8082C8.70402 27.0333 8.55143 26.2872 8.2692 25.5884C6.13295 20.2991 -0.147993 16.0332 -0.147995 10.3288L-0.147997 2.95067Z",
    fill: "#EBDBAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLinkHover);
export default __webpack_public_path__ + "static/media/active-link-hover.ffa933dee23222577ba3cbf26c0f0b53.svg";
export { ForwardRef as ReactComponent };